import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=bfbe0904&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"
import style0 from "./Loading.vue?vue&type=style&index=0&id=bfbe0904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbe0904",
  null
  
)

export default component.exports